// Phone-only (<600px) stacked-card layout for MUI tables. Desktop/tablet tables are untouched.
// Body cells need a data-label attribute; the header row is hidden at this size.
export const mobileCardTableSx = (labelColor, dividerColor) => ({
    '@media (max-width:599.95px)': {
        minWidth: '0 !important',
        '&, & tbody': { display: 'block' },
        '& thead': { display: 'none' },
        '& tbody tr': {
            display: 'block',
            borderBottom: `3px solid ${dividerColor}`,
            pb: 0.5,
        },
        '& tbody td': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            textAlign: 'right',
            width: 'auto !important',
            py: 0.75,
            overflowWrap: 'anywhere',
        },
        '& tbody td[data-label]::before': {
            content: 'attr(data-label)',
            fontWeight: 700,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            color: labelColor,
            textAlign: 'left',
            flexShrink: 0,
        },
        '& tbody td[colspan]': { display: 'block', textAlign: 'center' },
    },
});
